import http from "@/utils/http";

export interface ISearchMaterialLinkEngineerProps {
  id: number;
  page: number;
  page_size: number;
}

export interface IGraphQEngineerItem {
  aspect: string;
  id: number;
  is_example: number;
  project_id: number;
  team_id: number;
  title: string;
  type: number;
  version: number;
  updated_at: number;
  owner: {
    avatar: string;
    avatar_color: string;
    nickname: string;
    phone_number: string;
    uuid: string;
  };
}

export const queryFields: string[] = [
  "id",
  "team_id",
  "project_id",
  "title",
  "type",
  "version",
  "aspect",
  "updated_at",
  "owner_uuid",
  "owner { uuid phone_number avatar avatar_color nickname }",
  "is_example",
];

const generateGraphQLQuery =
  (data: ISearchMaterialLinkEngineerProps) =>
  (fields: string[]): string => {
    const selectedFields = fields.join("\n");
    const searchParams: string[] = [];
    if (data.id !== undefined) searchParams.push(`id: ${data.id}`);
    const searchStr = searchParams.join(", ");
    return `{
        material_related_sessions (${searchStr}){
         ${selectedFields} 
      }
    }`;
  };

export const getMaterailLinkEngineerList = async (
  data: ISearchMaterialLinkEngineerProps,
): Promise<{
  data: IGraphQEngineerItem[];
  total: number;
}> => {
  const result = await http.post(
    `/api/v1/graphql/`,
    generateGraphQLQuery(data)(queryFields).toString(),
    {
      headers: {
        "Content-Type": "application/graphql",
      },
    },
  );
  console.log(result);
  return {
    data: result?.data?.material_related_sessions || [],
    total: result?.data?.material_related_sessions || 0,
  };
};
